import { auth, database } from "<config>/firebase";
import { collection, limit, query, getDocs } from "~/utils/firebase/firestore";
import { handleError } from "~/utils/logger";

export async function validateAndFixAuthSession() {
  const user = auth.currentUser;

  if (!user) {
    return;
  }

  try {
    const q = query(collection(database, "location_data"), limit(1));
    const locationDataDoc = await getDocs(q);

    if (!locationDataDoc.docs.length) {
      throw new Error("No matching location document — possible mismatch");
    }
    return true;
  } catch (err: any) {
    if (
      err.code === "permission-denied" ||
      err.message?.includes("mismatch") ||
      err.code === "unauthenticated"
    ) {
      handleError("Session seems invalid or mismatched, signing out...");
    } else {
      handleError("Unexpected error during session check");
    }
  }
}
